import { Component, inject, signal } from '@angular/core';
import { EmployeesService } from '@apps/landing/src/app/modules/about-us/services/employees.service';
import { SharedModule } from '@apps/landing/src/app/shared/shared.module';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageCardComponent } from '@apps/landing/src/app/shared/components/cards/image-card/image-card.component';
import { CompoundCardComponent } from '@apps/landing/src/app/shared/components/cards/compound-card/compound-card.component';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmSkeletonComponent } from '@spartan-ng/ui-skeleton-helm';
import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';
import { IEmployeeModel } from '@apps/landing/src/app/modules/about-us/models/employee.model';
import { finalize, takeUntil } from 'rxjs';
import { handleResponseMessage, RESPONSE_TYPE } from '@apps/landing/src/app/shared/utils/handle-response-message';
import { Unsubscribe } from '@apps/landing/src/app/shared/classes/unsubscribe';

@Component({
  selector: 'app-employee-details',
  imports: [SharedModule, ImageCardComponent, CompoundCardComponent, HlmButtonDirective, HlmSkeletonComponent],
  standalone: true,
  templateUrl: './employee-details.component.html',
})
export class EmployeeDetailsComponent extends Unsubscribe {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly employeesService = inject(EmployeesService);

  private handleResponseMessage = handleResponseMessage();
  protected readonly loading = signal<boolean>(false);
  protected readonly employee = signal<IEmployeeModel | null>(null);

  ngOnInit(): void {
    const idFromRoute = this.route.snapshot.paramMap.get('id');
    if (idFromRoute) {
      this.getEmployeeData(idFromRoute);
    } else {
      this.router.navigate([PAGE_ROUTES.ABOUT_US]);
    }
  }

  protected getEmployeeData(id: string) {
    this.loading.set(true);

    this.employeesService
      .getEmployeeById(id)
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => this.loading.set(false))
      )
      .subscribe({
        next: response => {
          if (response.status && response.data) {
            this.employee.set({
              ...this.employeesService.employeeMockData,
              ...response.data,
              fullName: `${response.data.firstName} ${response.data.lastName}`,
              image: response.data.gender?.toLowerCase() === 'female' ? 'assets/media/images/user3.svg' : 'assets/media/images/user2.svg',
            });
          } else {
            this.handleResponseMessage('Failed to get employee data', RESPONSE_TYPE.ERROR);
          }
        },
      });
  }
}
